import ProductHeading from './ProductHeading';

export default ProductHeading;
